import { bookingConfirmationRoute } from '@/features/public/booking/routes/bookingConfirmationRoute.ts';
import { Card, CardContent, CardTitle } from '@/components/ui/Card.tsx';
import { Check } from 'lucide-react';
import ActionButton from '@/components/buttons/ActionButton.tsx';

const BookingConfirmationPage = () => {
  const { tourBasicInfo } = bookingConfirmationRoute.useLoaderData();

  return (
    <div>
      <div className="mx-auto flex min-h-[80vh] items-center justify-center">
        <Card className="w-full max-w-[600px]">
          <CardContent className="space-y-4 py-6">
            <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-md bg-success-100">
              <Check className="size-10 text-success-300" />
            </div>
            <CardTitle className="text-center text-3xl font-semibold leading-snug text-base-text">
              Zarezerwowano miejsce <br />
              {'na obóz '}
              {tourBasicInfo.tourName}
            </CardTitle>
            <div className="space-y-2 text-center text-sm text-neutral-600">
              <p>
                Twoja rezerwacja została zapisana, wysłaliśmy Ci
                <br /> też potwierdzenie na Twój adres email
              </p>
            </div>

            <div className="flex justify-center">
              <ActionButton
                tone="accent"
                size="sm"
                onClick={() => {
                  window.location.href = '/';
                }}
              >
                Powrót do strony głównej
              </ActionButton>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default BookingConfirmationPage;
